//* Libraries imports
import React from "react";
import { Container } from "@mui/material";

//* Components Imports
import ScrollTransition from "components/ScrollTransition";

//* Styles Imports
import styles from "./styles.module.css";

//* Assets Imports
import businessmanImg from "assets/static/landing/businessman_stairs.png";

function BuyerSection() {
  return (
    <section
      id="buyer-section"
      data-testid="buyer-section"
      aria-label="Seção sobre a transformação do comportamento do comprador"
      className={styles.buyerSection}
    >
      <Container
        id="buyer-container"
        data-testid="buyer-container"
        aria-label="Container do novo comprador"
        maxWidth="xl"
      >
        <div
          id="buyer-grid"
          data-testid="buyer-grid"
          aria-label="Layout dividido do novo comprador"
          className={styles.buyerGrid}
        >
          <div
            id="buyer-text-container"
            data-testid="buyer-text-container"
            aria-label="Textos explicativos sobre a transformação do comprador"
            className={styles.buyerTextContainer}
          >
            <ScrollTransition
              id="buyer-title-transition"
              data-testid="buyer-title-transition"
              aria-label="Animação de entrada do título do comprador"
            >
              <h2
                id="buyer-title"
                data-testid="buyer-title"
                aria-label="Título: O novo comprador"
                className={styles.sectionTitle}
                style={{ textAlign: "left" }}
              >
                O NOVO <span className={styles.highlight}>COMPRADOR</span>
              </h2>
              <div
                id="buyer-divider"
                data-testid="buyer-divider"
                aria-label="Linha decorativa do novo comprador"
                className={styles.divider}
                style={{ margin: "1rem 0" }}
              />
            </ScrollTransition>

            <ScrollTransition
              id="buyer-details-transition"
              data-testid="buyer-details-transition"
              aria-label="Animação da descrição do novo comprador"
              delay={300}
            >
              <h3
                id="buyer-subtitle"
                data-testid="buyer-subtitle"
                aria-label="Subtítulo: Geração Conectada"
                className={styles.sectionSubtitle}
              >
                GERAÇÃO CONECTADA
              </h3>
              <p
                id="buyer-details-1"
                data-testid="buyer-details-1"
                aria-label="Parágrafo sobre a idade e preferência dos compradores"
                className={styles.buyerDetails}
              >
                Compradores entre <span className={styles.highlight}>30 e 45 anos</span> preferem resolver tudo via Smartphone/WhatsApp.
              </p>
              <p
                id="buyer-details-2"
                data-testid="buyer-details-2"
                aria-label="Parágrafo sobre a solução de escassez de mão de obra"
                className={styles.buyerDetails}
              >
                Resolvemos a escassez de mão de obra de atendimento físico conectando sua loja a quem já está online.
              </p>
            </ScrollTransition>
          </div>

          <div
            id="buyer-image-wrapper"
            data-testid="buyer-image-wrapper"
            aria-label="Imagem ilustrativa do comprador moderno no topo de uma escada"
            className={styles.buyerImageWrapper}
          >
            <ScrollTransition
              id="buyer-image-transition"
              data-testid="buyer-image-transition"
              aria-label="Animação da imagem do comprador"
              delay={200}
            >
              <img
                id="buyer-image"
                data-testid="buyer-image"
                aria-label="Imagem de um homem de negócios na escada"
                src={businessmanImg}
                alt="O Novo Comprador"
                className={styles.buyerImage}
              />
            </ScrollTransition>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default BuyerSection;
